import store from '../store/index.js'

export function msg(Message, Timeout = null, Color = 'warning') {
    store.dispatch('snackbar/openMsg', {
        "msg": Message,
        "timeout": Timeout,
        "color": Color
    })
}

export function openLoding() {
    store.dispatch('overlay/openOverlay')
}

export function closeLoding() {
    store.dispatch('overlay/closeOverlay')
}

export function setLoginStatus(status) {
    store.dispatch('setLoginStatus', status)
}